import { Button } from '@abyss/web/ui/Button/v1';
import { Text } from '@abyss/web/ui/Text';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { PortalContext } from '../../context/PortalContext';
import { useConfig } from '../../frontends/ProviderSearch/context/Analytics';
import { getLanguage } from '../../frontends/ProviderSearch/context/Internationalization/helpers';
import { adobeLinkTrackEvent } from '../AdobeTagging/adobeLinkTrackEvent';
import { LAWW_PORTAL_NAME } from '../Constants';
import { LinkWithTracking } from '../LinkWithTracking/LinkWithTracking';
import {
  AdditionalFeedbackContainer,
  AdditionalFeedbackInstruction,
  reportingLinkStyles,
} from './index.style';

export const ReportAdditionalFeedback = () => {
  const { t } = useTranslation();
  const locale = getLanguage().code;
  const { portalData } = useContext(PortalContext);

  const additionalReportingEnglishLink = useConfig(
    'FEEDBACK_FORM_ADDITIONAL_REPORTING_DEFAULT'
  );
  const additionalReportingSpanishLink = useConfig(
    'FEEDBACK_FORM_ADDITIONAL_REPORTING_SPANISH'
  );
  const email = useConfig('FEEDBACK_FORM_SUPPORT_EMAIL');
  const externalReportingLink =
    locale === 'es'
      ? additionalReportingSpanishLink
      : additionalReportingEnglishLink;

  const handleExternalLinkClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const newWindow = window.open(externalReportingLink, '_blank');

    // Fallback: reload the full URL after a short delay
    setTimeout(() => {
      if (newWindow) {
        newWindow.location.href = externalReportingLink;
      }
    }, 5000);
  };
  return (
    <React.Fragment>
      <AdditionalFeedbackContainer>
        <AdditionalFeedbackInstruction>
          <Text
            color="$interactive"
            css={{
              display: 'block',
              paddingBottom: '4px',
              lineHeight: '22.4px',
            }}
            data-auto-testid="feedback-report-options-heading"
            data-testid="feedback-report-options-heading"
            fontWeight="600"
            size="16px"
          >
            {t('FEEDBACK_FORM.REPORT_OPTIONS')}
          </Text>
          <Text
            css={{ display: 'block', lineHeight: '22.4px' }}
            data-auto-testid="feedback-report-by-phone-or-email-text"
            data-testid="feedback-report-by-phone-or-email-text"
            fontWeight="400"
          >
            {portalData?.portalName === LAWW_PORTAL_NAME
              ? t('FEEDBACK_FORM.REPORT_BY_PHONE_OR_EMAIL_LAWW')
              : t('FEEDBACK_FORM.REPORT_BY_PHONE_OR_EMAIL')}
          </Text>
          <Button
            color="$interactive1"
            css={{
              borderBottom: '1px solid $interactive1',
              lineHeight: '18px',
              fontWeight: '400',
              padding: 0,
              height: 'none',
            }}
            data-auto-testid="email-address"
            data-testid="email-address"
            href={`mailto:${email}`}
            onClick={() =>
              adobeLinkTrackEvent({
                name: 'email send feedback',
                location: 'body:details header',
                type: 'email',
                destinationUrl: `mailto:${email}`,
              })
            }
            variant="tertiary"
          >
            {email}
          </Button>
        </AdditionalFeedbackInstruction>
        <LinkWithTracking
          css={reportingLinkStyles}
          data-auto-testid="additional-reporting-page-link-text"
          data-testid="additional-reporting-page-link-text"
          onClick={handleExternalLinkClick}
          openNewWindow={true}
        >
          <Text color="$interactive1" fontWeight="600" size="18px">
            {t('FEEDBACK_FORM.ADDITIONAL_REPORTING_RESOURCES')}
          </Text>
        </LinkWithTracking>
      </AdditionalFeedbackContainer>
    </React.Fragment>
  );
};
